export const PERMISSIONS_SET_LIST_DATA = 'PERMISSIONS_SET_LIST_DATA';
export const PERMISSIONS_SET_LIST_META = 'PERMISSIONS_SET_LIST_META';
export const PERMISSIONS_TITLE="Quyền người dùng";